import { render } from "./FilterWidget.vue?vue&type=template&id=225dac67"
import script from "./FilterWidget.vue?vue&type=script&lang=js"
export * from "./FilterWidget.vue?vue&type=script&lang=js"

import exportComponent from "/home/mw/Code/hc-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__